/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Linear_PricingInputs */

const en_mk_cmp_linear_pricing = /** @type {(inputs: Mk_Cmp_Linear_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free $0 · Basic $10 · Business $16 per seat per month (billed annually) · Enterprise by agreement. AI credits prepaid separately, $10 minimum.`)
};

const id_mk_cmp_linear_pricing = /** @type {(inputs: Mk_Cmp_Linear_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free $0 · Basic $10 · Business $16 per kursi per bulan (tagihan tahunan) · Enterprise sesuai kesepakatan. Kredit AI prabayar terpisah, minimum $10.`)
};

/**
* | output |
* | --- |
* | "Free $0 · Basic $10 · Business $16 per seat per month (billed annually) · Enterprise by agreement. AI credits prepaid separately, $10 minimum." |
*
* @param {Mk_Cmp_Linear_PricingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_linear_pricing = /** @type {((inputs?: Mk_Cmp_Linear_PricingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Linear_PricingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_linear_pricing(inputs)
	return en_mk_cmp_linear_pricing(inputs)
});